import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ContentStateProperty, ScreenProperty } from '../../../../../../../@types/types'
import { SCREEN_OTHER_FACILITIES, SCREENS } from '../../../../../../../services/domain/wizardScreens'
import ToggleSwitch from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'
import CombinedFieldItem from '../../../../../../common/inputs/combinedFieldItem/CombinedFieldItem'

const screen = SCREENS[SCREEN_OTHER_FACILITIES]

const fieldId = 'crane'

export interface CraneProps {
  screenId: string
  crane?: boolean
  craneValue?: string
  craneValueValidation: string[]
  onChange: (property: ContentStateProperty, value: string | boolean | undefined) => void
  doReset: (clearingUpOf: ScreenProperty[]) => void
}

const Crane: React.FC<CraneProps> = ({ crane, craneValue, craneValueValidation, onChange, doReset }) => {
  const { t } = useTranslation()
  const [hasCrane, setCrane] = useState<boolean>(crane ?? false)

  const doToggle = () => {
    setCrane((prev) => !prev)
    hasCrane && callReset()
    !hasCrane && onChange('crane', true)
  }

  const callReset = () =>
    doReset([
      {
        screen: screen.name,
        property: 'crane',
      },
      {
        screen: screen.name,
        property: 'craneValue',
      },
    ])

  useEffect(() => (crane ? setCrane(true) : undefined), [crane])

  return (
    <div className='grid-item one-whole'>
      <ToggleSwitch
        id={fieldId}
        alignment='custom'
        propertyName='crane'
        label={<span>{t('wizard.screen.otherFacilities.crane', 'Crane')}</span>}
        value={hasCrane}
        onChange={doToggle}
      />

      {hasCrane && (
        <CombinedFieldItem
          id={`${fieldId}-value`}
          label={t('wizard.screen.otherFacilities.craneValue', 'Crane Value')}
          wrapperClassName='margin-top-l'
          children={
            <TextInput
              id={`${fieldId}-value`}
              propertyName='craneValue'
              placeholder=''
              label=''
              value={craneValue}
              type='text'
              affixRight='unit'
              unitRight='t'
              maxLength={8}
              errors={craneValueValidation}
              doOnFieldChange={(property, value) => onChange(property, value !== '' ? value : undefined)}
            />
          }
        />
      )}
    </div>
  )
}

export default Crane
